// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as TitleCmp$PorterinFeature from "./TitleCmp.mjs";
import * as FareEstimateStore$PorterinFeature from "../../../../../shared/core/constants/FareEstimateStore.mjs";
import * as AutoCompleteCardCmp$PorterinFeature from "./AutoCompleteCardCmp.mjs";
import * as AutoCompleteCardSectionCmpModuleScss from "../../styles/AutoCompleteCardSectionCmp.module.scss";

var styles = AutoCompleteCardSectionCmpModuleScss;

function AutoCompleteCardSectionCmp(Props) {
  var places_list = Props.places_list;
  var on_address_select = Props.on_address_select;
  return React.createElement("div", {
              className: styles["search-results"]
            }, React.createElement(TitleCmp$PorterinFeature.make, {
                  title: FareEstimateStore$PorterinFeature.search_results_title,
                  class_name: styles.title
                }), Belt_Array.map(places_list, (function (place_info) {
                    return React.createElement(AutoCompleteCardCmp$PorterinFeature.make, {
                                place_info: place_info,
                                on_address_select: Curry.__1(on_address_select)
                              });
                  })));
}

var make = AutoCompleteCardSectionCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
